import { auth, firestore, storage } from "../../firebase";
import {
  SET_LOADING,
  RESET_LOADING,
  LOAD_USER_PROFILE,
  SET_USER_TRACKS,
  LOAD_USERS,
} from "../types";
import UIkit from "uikit";
import { Dispatch } from "redux";
import { Track } from "../../models/track";
import { User } from "../../models/user";
import { iusr } from "../reducers/authReducer";

export const getUser = (username: string | undefined | null) => async (
  dispatch: Dispatch
) => {
  dispatch({
    type: SET_LOADING,
  });
  try {
    let u = auth.currentUser;

    if (username) {
      firestore
        .collection("users")
        .where("username", "==", username)
        .limit(1)
        .onSnapshot(async (snap) => {
          let user: User = iusr;
          if (!snap.empty) {
            snap.forEach((usr) => {
              let data = usr.data();
              user = {
                pimage: "",
                accountType: data?.accountType,
                bio: data?.bio,
                email: data?.email,
                fans: data?.fans,
                firstName: data?.firstName,
                lastName: data?.lastName,
                location: data?.location,
                id: usr.id,
                username: data?.username,
                website: data?.website,
              };
            });

            try {
              let url = await storage
                .ref(`profiles/${user?.id}`)
                .getDownloadURL();

              if (url) {
                user.pimage = url;
              }

              dispatch({
                type: LOAD_USER_PROFILE,
                payload: user,
              });
            } catch (error) {
              dispatch({
                type: LOAD_USER_PROFILE,
                payload: user,
              });
            } finally {
              dispatch({
                type: RESET_LOADING,
              });
            }
          } else {
            dispatch({
              type: LOAD_USER_PROFILE,
              payload: null,
            });
          }
        });
    } else {
      if (u) {
        firestore
          .collection("users")
          .doc(u.uid)
          .onSnapshot(async (snap) => {
            let user = snap.data();
            if (snap.exists && user) {
              try {
                let url = await storage
                  .ref(`profiles/${user.uid}`)
                  .getDownloadURL();

                if (url) {
                  user.pimage = url;
                }

                dispatch({
                  type: LOAD_USER_PROFILE,
                  payload: user,
                });
                dispatch({
                  type: RESET_LOADING,
                });
              } catch (error) {
                dispatch({
                  type: RESET_LOADING,
                });
                dispatch({
                  type: LOAD_USER_PROFILE,
                  payload: user,
                });
              }
            }
          });
      }
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const fanMe = async (username: string) => {
  try {
    const l_user = auth.currentUser;
    if (l_user) {
      let ref = firestore
        .collection("users")
        .where("username", "==", username)
        .limit(1);
      let doc = await ref.get();

      if (!doc.empty) {
        let user: any;
        doc.forEach((usr) => {
          user = usr.data();
          user.uid = usr.id;
        });

        if (user) {
          let ref = firestore.collection("users").doc(user.uid);

          if (!user.fans.includes(l_user.uid)) {
            await ref.update({ fans: [...user.fans, l_user.uid] });
          } else {
            await ref.update({
              fans: user.fans.filter((fan: string) => fan !== l_user.uid),
            });
          }
        }
      }
    } else {
      UIkit.modal.dialog(
        `<p class="uk-modal-body">Login to use this feature</p>`
      );
    }
  } catch (error) {
    console.log(error);
  }
};

export const getUserTracks = (username: string) => async (
  dispatch: Dispatch
) => {
  try {
    if (username !== undefined) {
      let utracks: Track[] = [];
      let resp = await firestore
        .collection("songs")
        .where("username", "==", username)
        .get();

      if (!resp.empty) {
        resp.forEach((doc) => {
          let data = doc.data();
          let t: Track = {
            covername: data.covername,
            title: data.title,
            featured: data.featured,
            id: doc.id,
            likes: data.likes,
            plays: data.plays,
            src: data.src,
            tag: data.tag,
            uid: data.uid,
            username: data.username,
          };
          utracks = [...utracks, t];
        });
      }

      utracks.forEach(async (song) => {
        let ref = storage.ref(`/test/${song.src}`);
        ref.getDownloadURL().then((url) => {
          song.src = url;
        });
      });

      dispatch({
        type: SET_USER_TRACKS,
        payload: utracks,
      });
    }
  } catch (error) {}
};

export const getUserFans = (username: string) => {
  new Promise(async (res, rej) => {
    try {
      let user = auth.currentUser;
      if (!user) return res(false);
      let ref = await firestore
        .collection("users")
        .where("username", "==", username)
        .get();
      if (ref.empty) {
        return res(false);
      } else {
        ref.forEach((doc) => {
          if (doc.data().fans.includes(user?.uid)) {
            return res(true);
          } else {
            return res(false);
          }
        });
      }
    } catch (error) {
      console.log(error);
      return rej(false);
    }
  });
};

export const getUsers = () => async (dispatch: Dispatch) => {
  try {
    let users: User[] = [];
    let docs = (
      await firestore
        .collection("users")
        .where(`accountType`, "==", `artist`)
        .get()
    ).docs;
    docs.forEach((doc) => {
      let data = doc.data();
      let user: User = {
        accountType: data.accountType,
        bio: data.bio,
        email: data.email,
        fans: data.fans,
        firstName: data.firstName,
        id: doc.id,
        lastName: data.lastName,
        location: data.location,
        pimage: "",
        username: data.username,
        website: data.website,
      };
      users = [...users, user];
    });
    dispatch({
      type: LOAD_USERS,
      payload: users,
    });
  } catch (error) {
    console.log(error);
  }
};
